<template>
    <v-snackbars :timeout="timeout" :objects.sync="messages" bottom right>
        <template v-slot="scope">
            <div class="d-flex flex-no-wrap">
                <div class="d-flex align-items-center">
                    <v-icon class="mr-3 pa-0">
                        {{ scope.message.icon }}
                    </v-icon>
                </div>

                <div class="d-flex align-items-center" data-cy="toast-message" v-html="tHtml(scope.message.text)"></div>
            </div>
        </template>

        <template v-slot:action="{ close }">
            <v-btn text @click="close()" data-cy="toast-close-button">{{ tb('Fechar') }}</v-btn>
        </template>
    </v-snackbars>
</template>

<script>
import VSnackbars from 'v-snackbars';
export default {
    components: {
        'v-snackbars': VSnackbars,
    },

    data: () => ({
        messages: [],
        timeout: 5000,
    }),

    created() {
        window.EventBus.$on('notify', this.notify);
    },

    methods: {
        /**
         * We want to ensure that repeated messages do not appear on the screen.
         * Messages that have appeared more than `timeout` (ms) ago can appear.
         */
        notify(notification) {
            notification.time = Date.now();
            notification.quantity = 1;

            // Get the messages that are on the screen (i.e. have a lifetime of less than X seconds.)
            const messagesOnScreen = this.messages.filter((n) => {
                const timeoutSecondsAgo = Date.now() - this.timeout;
                const isOnScreen = timeoutSecondsAgo < n.time;

                return isOnScreen;
            });

            // Is there a notification with the same text as the one we're about to show?
            let exists = false;
            for (const n of messagesOnScreen) {
                if (n.message.text === notification.message.text) {
                    exists = true;
                }
            }

            if (!exists) {
                this.messages.push(notification);
            }
        },
    },
};
</script>
